import { React } from "react";
import styled from "styled-components";

const AlertInfo = styled.div`
    box-sizing: border-box;
    display: flex;
    gap: 12px;
    align-items: flex-start;
    padding: 14px 16px;
    border-radius: 10px;
    background: #fdf0f0;
    border: 1px solid #f5c6c6;
    border-left: 4px solid #c41306;
    width: 100%;

    .icon {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: #c41306;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 700;
        line-height: 1;
    }

    .content {
        h2 {
            margin: 0 0 6px 0;
            font-size: 15px;
            font-weight: 700;
            color: #a30f05;
            line-height: 1.3;
        }

        p {
            margin: 0;
            font-size: 13px;
            font-weight: 400;
            color: #4d4d4d;
            line-height: 1.5;
        }
    }
`

const AlertCard = ({ passedAlert }) => {
    if (!passedAlert) {
        return null; // Don't render anything if alert is undefined
    }

    const title = passedAlert.title ?? "Unknown Title";
    const description = passedAlert.description ?? "No Description";

    return (
        <AlertInfo>
            <span className="icon">!</span>
            <div className="content">
                <h2>{title}</h2>
                <p>{description}</p>
            </div>
        </AlertInfo>
    );
};

export default AlertCard;
